import Player from '@vimeo/player'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const selector = '.video-sound'

export default (
    el = null
) => {
    if (!el)
        return

    const section = el.closest('section')

    if (!section)
        return

    console.groupCollapsed('Video Sound')

    let isMuted = true

    const iframe = section
        .querySelector('iframe')

    const video = section
        .querySelector('video')

    const checkAudio = () => {
        const hasAudio = video
            && (video.mozHasAudio
                || Boolean(video.webkitAudioDecodedByteCount)
                || Boolean(video.audioTracks && video.audioTracks.length))

        if (!hasAudio)
            el.style = 'display: none'
    }

    if (video)
        video.readyState
            ? checkAudio()
            : video.onloadeddata = () => {
                checkAudio()
            }

    const vimeo = iframe
            && iframe.src.includes('vimeo')
        ? new Player(iframe)
        : null

    const btn = el
        .querySelector('button')

    const toggleBtn = () => btn
        .classList.toggle('video-sound-on')

    const videoCtrl = (muted) => {
        video.muted = muted
    }

    const videoSound = () => {
        isMuted = !isMuted

        video
            ? videoCtrl(isMuted)
            : vimeo.setMuted(isMuted)

        toggleBtn()
    }

    const videoScroll = () => {
        isMuted = true

        video
            ? videoCtrl(isMuted)
            : vimeo.setMuted(isMuted)

        btn.classList
            .remove('video-sound-on')
    }

    if ((video || vimeo) && btn) {
        btn.addEventListener('click',
            videoSound)

        ScrollTrigger.create({
            trigger: section,
            onLeave: () => videoScroll(),
            onLeaveBack: () => videoScroll()
        })
    }

    if (import.meta.hot)
        import.meta.hot
            .on('vite:beforeUpdate', () => {
                if ((video || vimeo) && btn)
                    btn.removeEventListener('click',
                        videoSound)
            })

    // Log instance
    console.log(el)

    console.groupEnd()

    return el
}
